<template>
  <auth-layout pageClass="login-page">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :color="'#f18f00'"
      :is-full-page="false"
      :height="100"
      :width="255"
      :opacity="0.8"
      class="custom-loading-dash"
    >
    </loading>
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-lg-4 col-md-6 col-sm-8 c-card">
        <fade-render-transition>
          <card>
            <div slot="header">
              <h5 class="card-title text-center" style="margin-bottom: 10px">
                {{ $t('vie.Pag.Aut.PasswordReset.passwordPolicy') }}
              </h5>
            </div>
            <div>
              <div id="rr" class="custom-control custom-switch">
                <l-switch
                  v-bind:value="/[A-Z]/.test(this.user.password) ? true : false"
                  color="green"
                >
                  <em class="fa fa-check" slot="on"></em>
                  <em class="fa fa-times" slot="off"></em>
                </l-switch>
                {{ $t('vie.Pag.Aut.PasswordReset.minimumOneCapitalLetter') }}
              </div>
              <div class="custom-control custom-switch">
                <l-switch
                  v-bind:value="/[a-z]/.test(this.user.password) ? true : false"
                  color="green"
                >
                  <em class="fa fa-check" slot="on"></em>
                  <em class="fa fa-times" slot="off"></em>
                </l-switch>
                {{ $t('vie.Pag.Aut.PasswordReset.minimumOneLowercase') }}
              </div>
              <div class="custom-control custom-switch">
                <l-switch
                  v-bind:value="/[0-9]/.test(this.user.password) ? true : false"
                  color="green"
                >
                  <em class="fa fa-check" slot="on"></em>
                  <em class="fa fa-times" slot="off"></em>
                </l-switch>
                {{ $t('vie.Pag.Aut.PasswordReset.atLeastOneNumber') }}
              </div>
              <div class="custom-control custom-switch">
                <l-switch
                  v-bind:value="this.user.password.length > 7 ? true : false"
                  color="green"
                >
                  <em class="fa fa-check" slot="on"></em>
                  <em class="fa fa-times" slot="off"></em>
                </l-switch>
                {{ $t('vie.Pag.Aut.PasswordReset.minimum8Characters') }}
              </div>
              <div class="custom-control custom-switch">
                <l-switch
                  v-bind:value="
                    /[.:,;<>¿¡=#@$!%\*\+\-\}\{\)\(\/|\_?&]/.test(
                      this.user.password
                    )
                      ? true
                      : false
                  "
                  color="green"
                >
                  <em class="fa fa-check" slot="on"></em>
                  <em class="fa fa-times" slot="off"></em>
                </l-switch>
                {{ $t('vie.Pag.Aut.PasswordReset.atLeastOneSpecialCharacter') }}
              </div>
              <div class="custom-control custom-switch">
                <l-switch
                  v-bind:value="
                    this.user.password == this.user.password_confirmation &&
                    this.user.password.length > 7
                      ? true
                      : false
                  "
                  color="green"
                >
                  <em class="fa fa-check" slot="on"></em>
                  <em class="fa fa-times" slot="off"></em>
                </l-switch>
                {{ $t('vie.Pag.Aut.PasswordReset.mustBeTheSame') }}
              </div>
            </div>
          </card>
        </fade-render-transition>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-8">
        <form method="POST" class="form-login">
          <fade-render-transition>
            <card>
              <div slot="header">
                <h3 class="card-title text-center">
                  {{ $t('vie.Pag.Aut.PasswordReset.resetPassword') }}
                </h3>
                <br />
              </div>
              <div>
                <fg-input
                  :placeholder="$t('vie.Pag.Aut.PasswordReset.emailOrUser')"
                  v-model="user.login"
                  v-validate="modelValidations.user"
                  :error="getError('common_words.user', true)"
                  name="common_words.user"
                  v-on:keyup="validate"
                  type="text"
                >
                </fg-input>
                <fg-input
                  :placeholder="$t('common_words.password')"
                  v-model="user.password"
                  v-on:keyup="validatePolicys"
                  :type="showPass.inputTypePass"
                  :myCustom="{ addon: 'not-input-group-addon' }"
                >
                  <template slot="addonRight">
                    <l-button @click="showPassword('1')" class="btn-round">
                      <em :class="showPass.iconBtnPass"></em>
                    </l-button>
                  </template>
                </fg-input>
                <fg-input
                  :placeholder="$t('common_words.confirm_password')"
                  v-model="user.password_confirmation"
                  v-on:keyup="validatePolicys"
                  :type="showPass.inputTypePass"
                  :myCustom="{ addon: 'not-input-group-addon' }"
                >
                  <template slot="addonRight">
                    <l-button @click="showPassword('1')" class="btn-round">
                      <em :class="showPass.iconBtnPass"></em>
                    </l-button>
                  </template>
                </fg-input>
              </div>
              <br />
              <div class="text-center">
                <button
                  type="submit"
                  id="btnReset"
                  class="btn btn-fill btn-info btn-round btn-wd"
                  :disabled="enabledBtn"
                  @click.prevent="validateSubmit"
                >
                  {{ $t('common_words.confirm_changes') }}
                </button>
              </div>
              <div class="mt-3 text-center d-flex justify-content-center">
                <menu-translate :isSelect="true" :showAbbreviation="false" />
              </div>
            </card>
          </fade-render-transition>
        </form>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-8 c-card">
        <fade-render-transition>
          <card>
            <div slot="header">
              <h5 class="card-title text-center" style="margin-bottom: 10px">
                {{ $t('vie.Pag.Aut.PasswordReset.otherPolicies') }}
              </h5>
            </div>
            <div>
              <ul>
                <li>
                  {{ $t('vie.Pag.Aut.PasswordReset.otherPoliciesText1') }}
                </li>
                <li>
                  {{ $t('vie.Pag.Aut.PasswordReset.otherPoliciesText2') }}
                </li>
                <li>
                  {{ $t('vie.Pag.Aut.PasswordReset.otherPoliciesText3') }}
                </li>
                <li>
                  {{ $t('vie.Pag.Aut.PasswordReset.otherPoliciesText4') }}
                </li>
                <li>
                  {{ $t('vie.Pag.Aut.PasswordReset.otherPoliciesText5') }}
                </li>
              </ul>
            </div>
          </card>
        </fade-render-transition>
      </div>
    </div>
    <app-politics v-model="showPolitics" :policy="policy" @confirm="confirm" />
  </auth-layout>
</template>
<script>
import {
  Checkbox as LCheckbox,
  FadeRenderTransition,
  Switch as LSwitch,
} from 'src/components/index';
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapActions } from 'vuex';
import { setLocalizeLanguage } from 'src/util/Util';
import AppPolitics from './AppPolitics.vue';
import AuthLayout from 'src/views/Layouts/AuthLayout.vue';
import axios from 'axios';
import i18n from 'src/i18n';
import Loading from 'vue-loading-overlay';
import MenuTranslate from 'src/views/Layouts/MenuTranslate.vue';
import mixinMasters from 'src/util/mixinMasters.js';
import mixinPolitics from 'src/mixins/mixin-politics';
import MixinForm from 'src/mixins/forms/mixin-form';
import SweetAlert from 'src/class/Alerts';
import VeeValidate from 'vee-validate';
import Vue from 'vue';

Vue.use(VeeValidate);
setLocalizeLanguage();

export default {
  components: {
    AppPolitics,
    AuthLayout,
    FadeRenderTransition,
    LCheckbox,
    Loading,
    LSwitch,
    MenuTranslate,
  },
  data() {
    return {
      enabledBtn: true,
      // datos de usuario
      user: {
        login: '',
        password: '',
        password_confirmation: '',
        token: '',
      },
      // mostrar/ocultar pass
      showPass: {
        inputTypePass: 'password',
        inputTypePass2: 'password',
        iconBtnPass: 'fa fa-eye',
        iconBtnPass2: 'fa fa-eye',
      },
      // validar políticas pass
      policys: {
        upper: false,
        lower: false,
        digit: false,
        lenght: false,
        special: false,
        same: false,
      },
      // validar usuario
      modelValidations: {
        user: {
          required: true,
        },
      },
    };
  },

  mixins: [mixinMasters, MixinForm, mixinPolitics],

  methods: {
    // mapeamos las acciones de nuestro store para poder llamarlas desde este script
    ...mapActions({
      login: 'auth/login',
      passwordReset: 'auth/passwordReset',
    }),

    toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },

    closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    },

    // llamamos a nuestra accion passwordReset del store pasandole los datos de usuario
    passReset() {
      this.isLoading = true;
      this.passwordReset(this.user)
        .then((response) => {
          // si el cambio se realiza, lo enviamos al home despues despues de unos segundos
          SweetAlert.success(
            i18n.t('vie.Pag.Aut.PasswordReset.passwordHasBeenReset')
          );
          setTimeout(() => {
            // this.$router.push('/');
            this.validatePolitics();
          }, 3000);
        })
        .catch((e) => {
          this.showMessageErrors(e);
          this.isLoading = false;
        });
    },

    // este metodo permite mostrar/ocultar las contraseñas
    showPassword(input_num) {
      if (input_num === '1') {
        if (this.showPass.inputTypePass === 'password') {
          this.showPass.iconBtnPass = 'fa fa-eye-slash';
          this.showPass.inputTypePass = 'text';
        } else {
          this.showPass.iconBtnPass = 'fa fa-eye';
          this.showPass.inputTypePass = 'password';
        }
      } else {
        if (this.showPass.inputTypePass2 === 'password') {
          this.showPass.iconBtnPass2 = 'fa fa-eye-slash';
          this.showPass.inputTypePass2 = 'text';
        } else {
          this.showPass.iconBtnPass2 = 'fa fa-eye';
          this.showPass.inputTypePass2 = 'password';
        }
      }
    },

    // con este metodo validamos que la contraseña escrita, cumpla con las políticas
    validatePolicys() {
      this.policys.upper = /[A-Z]/.test(this.user.password) ? true : false;
      this.policys.lower = /[a-z]/.test(this.user.password) ? true : false;
      this.policys.digit = /[0-9]/.test(this.user.password) ? true : false;
      this.policys.lenght = this.user.password.length > 7 ? true : false;
      this.policys.special = /[.:,;<>¿¡=#@$!%\*\+\-\}\{\)\(\/|\_?&]/.test(
        this.user.password
      )
        ? true
        : false;
      this.policys.same =
        this.user.password == this.user.password_confirmation &&
        this.user.password.length > 7
          ? true
          : false;

      if (
        this.policys.upper &&
        this.policys.lower &&
        this.policys.digit &&
        this.policys.lenght &&
        this.policys.special &&
        this.policys.same
      ) {
        this.enabledBtn = false;
        //document.getElementById('btnReset').removeAttribute("disabled")
      } else {
        this.enabledBtn = true;
        //document.getElementById('btnReset').setAttribute("disabled", "")
      }
    },

    validate() {
      this.$validator
        .validateAll()
        .then((isValid) => {
          this.enabledBtn = !isValid;
        })
        .catch((e) => {
          this.enabledBtn = false;
        });
    },

    validateSubmit() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) this.passReset();
      });
    },
  },

  // con el ciclo de vida, validamos que el token de reset exista antes de cargar la pagina
  beforeCreate() {
    // hacemos una peticion axios para encontrar el token
    axios
      .get('/auth/find/' + this.$route.params.token)
      .then((response) => {
        // si existe lo asignamos a los datos de usuario
        this.user.token = response.data.data.token;
      })
      .catch((e) => {
        // si no existe mostramos una alerta y enviamos al usuario al login
        SweetAlert.danger(
          i18n.t('vie.Pag.Aut.PasswordReset.passwordChangeRequestExpired')
        );
        this.$router.push('/login');
      });

    axios
      .get('policyversions/index')
      .then((response) => {
        if (response.data.data) {
          this.policy = response.data.data[0];
        }
      })
      .catch((error) => {
        console.log(error);
        SweetAlert.warning(error.response.data.message);
      });
  },

  created() {
    this.isLoading = true;
  },

  mounted() {
    setTimeout(() => {
      this.isLoading = false;
    }, 1000);
  },
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}

.form-login .card .card-body {
  padding: 15px 20px 10px 20px !important;
}

.form-login .card .card-header,
.c-card .card .card-header {
  background-color: initial !important;
}
</style>
